<template>
	<div class="container-fluid">
		<hr>
		<div class="col">
			<a href="/ranking" class="btn btn-info">Back</a>
		</div>
		<hr>
		<div class="col col-lg-12" v-if="advanced">
			<h1><small>Search by company name</small></h1>
			<input type="text" class="form-control main-search" placeholder="company name..." v-model="company">
			<hr>
			<table  class="table" v-if="advanced">
				<thead>
					<tr>
						<th><h4>How important are the following to you:</h4></th>
						<th class="text-center"><small>Least<br>important</small><br>1</th>
						<th class="text-center">2</th>
						<th class="text-center">3</th>
						<th class="text-center">4</th>
						<th class="text-center"><small>Most<br>important</small><br>5</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th>Welcoming culture for military</th>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="1" /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="2"  /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="3"  /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="4"  /></td>
						<td><input type="radio" name="welcoming_culture_for_military" v-model="importantFilter.welcoming_culture_for_military"  class="form-control" value="5"  /></td>
					</tr>
					<tr>
						<th>Military/veteran recruiting</th>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting" class="form-control" value="1" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="2" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="3" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="4" ></td>
						<td><input type="radio" name="military_veteran_recruiting" v-model="importantFilter.military_veteran_recruiting"  class="form-control" value="5" ></td>
					</tr>
					<tr>
						<th>Military/veteran policies</th>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies" class="form-control" value="1" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="2" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="3" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="4" ></td>
						<td><input type="radio" name="military_veteran_policies" v-model="importantFilter.military_veteran_policies"  class="form-control" value="5" ></td>
					</tr>
					<tr>
						<th>Reservist/National Guard policies</th>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="1" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="2" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="3" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="4" ></td>
						<td><input type="radio" name="reservist_national_guard_policies" v-model="importantFilter.reservist_national_guard_policies"  class="form-control" value="5" ></td>
					</tr>
					<tr>
						<td colspan="6" class="text-left">
							<div class="row">
								<div class="col col-lg-3">
									<label>Industry
										<select class="form-control" v-model="importantFilter.industry">
											<option value="">No preference</option>
											<option>Accounting - Finance</option>
											<option>Airline - Aviation</option>
											<option>Banking - Financial Services</option>
											<option>Chemical</option>
											<option>Computer Software</option>
											<option>Construction</option>
											<option>Consulting</option>
											<option>Consumer Products</option>
											<option>Credit - Loan - Collections</option>
											<option>Defense - Aerospace</option>
											<option>Energy - Utilities - Gas - Electric</option>
											<option>Engineering - Services</option>
											<option>Environmental</option>
											<option>Fashion - Apparel - Textile</option>
											<option>Food</option>
											<option>Government - Civil Service</option>
											<option>Healthcare - Health Services</option></option>
											<option>Hotel - Resort</option>
											<option>Industrial</option>
											<option>Information Technology</option>
											<option>Insurance</option>
											<option>Manufacturing</option>
											<option>Media - Technology - Entertainment</option>
											<option>Oil Refining - Petroleum - Drilling</option>
											<option>Packaging</option>
											<option>Pharmaceutical</option>
											<option>Research & Development</option>
											<option>Retail</option>
											<option>Science & Technology</option>
											<option>Semiconductor</option>
											<option>Services - Corporate B2B</option>
											<option>Telecommunications</option>
											<option>Transportation</option>
										</select>
									</label>
								</div>
								<div class="col col-lg-3">
									<label>State
										<select2 class="form-control" :options="states" v-model="importantFilter.state">
									      <option disabled value="0">Select one</option>
									    </select2>
									</label>
								</div>
								<div class="col col-lg-3">
									<label>Company size
										<select class="form-control" v-model="importantFilter.company_size">
											<option value="">Any size</option>
											<option value="1">0-100 employees</option>
											<option value="2">101-10,000 employees</option>
											<option value="3">10,001-30,000 employees</option>
											<option value="4">More than 30,000 employees</option>
										</select>
									</label>
								</div>
								<div class="col col-lg-3">
									<label>% veteran employees
										<select class="form-control" v-model="importantFilter.veteran_employee_percentage">
											<option value="">Any proportion</option>
											<option value="2">At least 2.5%</option>
											<option value="5">At least 5%</option>
											<option value="10">At least 10%</option>
											<option value="20">At least 20%</option>
										</select>
									</label>
								</div>
							</div>
							
							
							
							
						</td>
					</tr>
					<tr class="text-left">
						<td colspan="6">
							<div class="row">
								<div class="col col-lg-12">
									<div class="checkbox">
									    <label>
									      <input type="checkbox" name="resource_group"  v-model="importantFilter.resource_group"> <strong>Military/veteran employee resource group</strong>
									    </label>
									</div>
									<div class="checkbox">
									    <strong>Military spouse work flexibility</strong>
									      <br><label><input type="checkbox" name="can_remotely"  v-model="importantFilter.can_remotely"> Can work remotely</label>
									      <br><label><input type="checkbox" name="can_utilize"  v-model="importantFilter.can_utilize"> Can utilize flexible scheduling options</label>
									      <br><label><input type="checkbox" name="can_transfer" v-model="importantFilter.can_transfer"> Can transfer to a different location</label>
									</div>
								</div>
		
							</div>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td colspan="5"><button class="btn btn-info" v-on:click="byFilter">SEARCH</button></td>
					</tr>
				</tfoot>
			</table>
		</div>

		<div class="col col-lg-12">
			<ul v-if="contents" class="list-unstyled">
				<li v-for="(content, index) in contents" class="mb-3 pb-0">
					<a  v-bind:href="'/company/' + content.id" class="row rounded border text-dark bg-white pb-1">
						<div class="col col-lg-3 pl-0 text-center">
							<div class="img-holder">
								<span class="order-number">{{ index + 1 }}</span>
								<img v-bind:src="(content.logo)?'https://s3.amazonaws.com/static.militarytimes.com/rebootcamp/'+ content.logo :'/images/placeholder.png'" class="img-responsive" >
							</div>
						</div>
						<div class="col-lg-4 mt-1">
							<h3 class="no-margin-header">{{ content.name }}</h3>
							<div><span class="glyphicon glyphicon-lock"></span> <strong>Industry:</strong> {{ content.industry.name }}</div>
							<div><span class="glyphicon glyphicon-map-marker"></span> <strong>Location:</strong> {{ content.location.name }}</div>
							<div><strong>Company size:</strong> {{ content.company_size }}</div>
						</div>
						<div class="col-lg-5">
							<div class="bg-light p-1 rounded border text-secondary mt-1 ">
								<label>Welcoming culture for military</label>
								<div class="progress">
								  <div class="progress-bar bg-success progress-bar-striped" role="progressbar" v-bind:aria-valuenow="content.display.welcoming_culture_for_military_veterans
	" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: content.display.welcoming_culture_for_military_veterans
	 + '%'}">
								  </div>
								</div>
							</div>
							<div class="bg-light p-1 rounded border text-secondary mt-1">
								<label>Military/veteran recruiting</label>
								<div class="progress">
								  <div class="progress-bar bg-info progress-bar-striped" role="progressbar" v-bind:aria-valuenow="content.display.military_veteran_recruiting" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: content.display.military_veteran_recruiting + '%'}">
								  </div>
								</div>
							</div>
							<div class="bg-light p-1 rounded border text-secondary mt-1">
								<label>Military veteran policies</label>
								<div class="progress">
								  <div class="progress-bar bg-warning progress-bar-striped" role="progressbar" v-bind:aria-valuenow="content.display.military_veteran_policies" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: content.display.military_veteran_policies + '%'}">
								    
								  </div>
								</div>
							</div>
							<div class="bg-light p-1 rounded border text-secondary mt-1">
								<label>Reservist/National Guard policies</label>
								<div class="progress">  
								  <div class="progress-bar bg-danger progress-bar-striped" role="progressbar" v-bind:aria-valuenow="content.display.reservist_national_guard_policies
	" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: content.display.reservist_national_guard_policies
	 + '%'}">
								  </div>
								</div>
							</div>
						</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['industry', 'state', 'company_size', 'veteran_employee_percentage', 'can_remotely', 'can_utilize', 'can_transfer', 'resource_group', 'welcoming_culture_for_military', 'military_veteran_recruiting', 'military_veteran_policies', 'reservist_national_guard_policies'],
		data: function(){
			return {
				company: '',
				advanced: false,
				contents: null,
				importantFilter: {
					industry: this.industry,
					state: this.state,
					company_size: this.company_size,
					veteran_employee_percentage: this.veteran_employee_percentage,
					can_remotely: this.can_remotely,
					can_utilize: this.can_utilize,
					can_transfer: this.can_transfer,
					resource_group: this.resource_group,
					welcoming_culture_for_military: this.welcoming_culture_for_military,
					military_veteran_recruiting: this.military_veteran_recruiting,
					military_veteran_policies: this.military_veteran_policies,
					reservist_national_guard_policies: this.reservist_national_guard_policies
				}
			}
		},
		created: function()
		{
			this.byFilter();
		},
		methods: {
			advancedSearch: function()
			{
				if(this.advanced){
					this.advanced = false; 
					return;
				}
				this.advanced = true
			},
			byCompany: function()
			{
				let self = this;
				axios.post('/api/bycompany', {
					name: self.company,
					_token: window.axios.defaults.headers.common['X-CSRF-TOKEN']
				})
				.then(function(response){
					self.contents = response.data;
				})
				.catch(function(error){
					console.log('error', error)
				});
			},
			byFilter: function()
			{
				let self = this;
				axios.post('/api/filter', self.importantFilter)
				.then(function(response){
					self.contents = response.data;
				})
				.catch(function(error){
					console.log('error', error)
				});

			}
		},
		watch: {
			company: function(){
				if(this.company.length < 3)
					return;
				this.byCompany();
			}
		}
	}
</script>